import React from 'react';
import { Navigate, useParams } from 'react-router';

/**
 * Permanent redirect for the retired offer review route. Backend notification
 * emails link to /trade-offers/:offerId (OfferNotificationService), so this
 * route must keep resolving indefinitely; the offers list scrolls to and
 * highlights the target row via the ?offer= param.
 */
export default function OfferDeepLinkRedirect() {
  const { offerId } = useParams<{ offerId: string }>();
  return (
    <Navigate
      to={offerId ? `/trade-offers?offer=${encodeURIComponent(offerId)}` : '/trade-offers'}
      replace
    />
  );
}
